import { createI18n } from 'vue-i18n'
import enGB from '@/locales/en-gb.json'
import deDe from '@/locales/de-de.json'
import esEs from '@/locales/es-es.json'
import frFr from '@/locales/fr-fr.json'
import itIt from '@/locales/it-it.json'
import nlNl from '@/locales/nl-nl.json'
const currentLocale = localStorage.getItem('gift-digital-user-locale') || 'en-gb'

const i18n = createI18n({
  locale: currentLocale,
  fallbackLocale: 'en-gb',
  allowComposition: true,
  legacy: false,
  globalInjection: true,
  messages: {
    "en-gb": enGB,
    "de-de": deDe,
    "es-es": esEs,
    "fr-fr": frFr,
    "it-it": itIt,
    "nl-nl": nlNl
  }
})

export default i18n
